import React, { Component } from "react";
import Header from "../HomeInteriors/Header";
import HIBasicBanner from "../HomeInteriors/HIBasicBanner";
import LocateusMain from "../HomeInteriors/LocateUs/LocateusMain";
import FormLocateUs from "../HomeInteriors/LocateUs/FormLocateUs";
import ChooseUs from "../HomeInteriors/Homepage/ChooseUs";
import StoreSelected from "../HomeInteriors/LocateUs/StoreSelected";
import StoreTextSection from "../HomeInteriors/LocateUs/StoreTextSection";
import MobileFixedNavbar from "../HomeInteriors/MobileFixedNavbar";
import { isMobile } from "../../utils/utilityManager";

export default class HILocateUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      store: {},
      storeSelected: false,
      storeCityMaster: [],
      citySelected: "",
      regions: [],
    };
  }

  onStoreSelect(store, storeMaster, citySelected, regions) {
    this.setState({
      store,
      storeSelected: true,
      storeCityMaster: storeMaster,
      citySelected,
      regions,
    });
    console.log(citySelected)
  }

  render() {
    return (
      <div className="home-interiors-page home-interiors-locateus">
        <Header
          source=''
          showModal
          pageSource="HI_LocateUs" />
        {isMobile() ? (
          <>
            <MobileFixedNavbar
              source=''
              showModal
              pageSource="HI_LocateUs" />
          </>
        ) : (
          <></>
        )}
        <HIBasicBanner espotName="GI_Interiors_LocateUs_Banner" pageSource = 'HI_LocateUs' />
        {
          !isMobile() ?
            <div className='title' style={{textAlign:"left", marginLeft:'5%', marginTop:'5%', color:'#337ab7'}}>
              <a href='/home-interiors' ><b>Home</b></a>  {`>`} Locate Us
            </div> :
            <div className='title' style={{textAlign:"left", marginLeft:'5%', marginTop:'5%', color:'#337ab7'}}>
              <a href='/home-interiors' ><b>Home</b></a>  {`>`} Locate Us
            </div>
        }
        {/* <StoreSelected /> */}
        {this.state.storeSelected == true ? (
          <StoreSelected
            selectedStore={this.state.store}
            storeMaster={this.state.storeCityMaster}
            cityData={this.state.citySelected}
          />
        ) : (
          <LocateusMain onStoreSelect={this.onStoreSelect.bind(this)} />
        )}

        <FormLocateUs />
        {this.state.storeSelected == true ? (
          <></>
        ) : (
          <>
            <ChooseUs espotName="GI_Interiors_ServicesOffered" />
            <StoreTextSection />
          </>
        )}
      </div>
    );
  }
}
